import React from 'react';
import { Box } from '../element';
import { NavLink } from '../link';
import { VerticalWizard, WizardStepFloatedItem } from '../wizard';
import Strings from '../../locales/Strings';

const StepSideBarItem = props => {
  const { steps, border, item, show, queryString } = props;
  const activeClass = show ? 'active' : '';
  return (
    <Box justify="start" border={border} fill={true} className="autoMinHeight">
      <NavLink
        className={'leftNavMenu ' + activeClass}
        to={item.path + queryString}
        data-test-id={`sidebar-${item.menuText}-link`}>
        {Strings[item.menuText]}
      </NavLink>
      {show && (
        <Box className="paddingTop3">
          <VerticalWizard
            steps={steps}
            category={item.menuText}
            queryString={queryString}
            element={<WizardStepFloatedItem />}
          />
        </Box>
      )}
    </Box>
  );
};

export default StepSideBarItem;
